// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';
import './headerSP.scss';
import NotifyNews from '../../notifyNews';
import { useHistory } from 'react-router-dom';
import { TOP_IMAGES } from '../../../../../assets/imgs';

export default function HeaderSP(props) {
  const { t } = useTranslation();
  const [isShowSubMenu, setShowSubMenu] = useState(false);

  const {
    gotoLogin,
    isLogin,
    handleLogout,
    gotoMyCollection,
    gotoNews,
    gotoRegister,
    gotoMyPage,
    gotoPurchaseHistory,
    gotoLottery,
    gotoGuide,
    gotoFrequentlyQuestion,
  } = props;

  const toggleMenu = () => {
    setShowSubMenu((isShowSubMenu) => !isShowSubMenu);
  };

  const history = useHistory();

  return (
    <header className="ol-header-sp">
      <div className="logo">
        <div
          onClick={() => {
            history.push('/');
          }}
        >
          <img src={TOP_IMAGES.LogoSP} />
        </div>

        <OutsideClickHandler
          onOutsideClick={() => {
            setShowSubMenu(false);
          }}
        >
          <svg
            onClick={toggleMenu}
            xmlns="http://www.w3.org/2000/svg"
            width="33.333"
            height="25.544"
            viewBox="0 0 33.333 25.544"
          >
            <g id="Group_7914" data-name="Group 7914" transform="translate(-173.023 -481.956)">
              <line
                id="Line_665"
                data-name="Line 665"
                x2="28.333"
                transform="translate(175.523 484.456)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
              <line
                id="Line_666"
                data-name="Line 666"
                x2="28.333"
                transform="translate(175.523 494.728)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
              <line
                id="Line_667"
                data-name="Line 667"
                x2="28.333"
                transform="translate(175.523 505)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
            </g>
          </svg>

          {isShowSubMenu && (
            <div className="sub-menu">
              {isLogin ? (
                <div className="sub-menu-item-wrap">
                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoMyPage();
                    }}
                  >
                    {t('menu.myPage')}
                  </div>
                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoPurchaseHistory();
                    }}
                  >
                    {t('menu.purchaseHistory')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoMyCollection();
                    }}
                  >
                    {t('menu.myCollection')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoLottery();
                    }}
                  >
                    {t('menu.Lottery')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoGuide();
                    }}
                  >
                    {t('menu.Guide')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoFrequentlyQuestion();
                    }}
                  >
                    {t('menu.FrequentlyQuestion')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      handleLogout();
                    }}
                  >
                    {t('logout')}
                  </div>
                </div>
              ) : (
                <div className="sub-menu-item-wrap">
                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      gotoLogin();
                      setShowSubMenu(false);
                    }}
                  >
                    {t('login')}
                  </div>
                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoLottery();
                    }}
                  >
                    {t('menu.Lottery')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoGuide();
                    }}
                  >
                    {t('menu.Guide')}
                  </div>

                  <div
                    className="sub-menu-item"
                    onClick={() => {
                      setShowSubMenu(false);
                      gotoFrequentlyQuestion();
                    }}
                  >
                    {t('menu.FrequentlyQuestion')}
                  </div>
                </div>
              )}
            </div>
          )}
        </OutsideClickHandler>
      </div>

      <div className="menu">
        {isLogin && (
          <div
            className="my-collection d-flex align-items-center justify-content-center"
            onClick={gotoMyCollection}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="99.055"
              height="17.352"
              viewBox="0 0 99.055 17.352"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_7065"
                    data-name="Rectangle 7065"
                    width="17.115"
                    height="17.352"
                    fill="none"
                  />
                </clipPath>
              </defs>
              <g id="Group_12776" data-name="Group 12776" transform="translate(10213.395 245)">
                <g id="Group_12760" data-name="Group 12760" transform="translate(44.714 -72.917)">
                  <path
                    id="Path_67296"
                    data-name="Path 67296"
                    d="M651.54,49.569l.044-1.65a.036.036,0,0,0-.033-.034c-.022,0-.032.012-.032.023L649.8,54.542a.919.919,0,0,1-1.012.737.879.879,0,0,1-.913-.737l-1.717-6.634c0-.011-.011-.023-.033-.023s-.032.012-.032.034l.044,1.65V54.52c0,.484-.243.759-.8.759a.692.692,0,0,1-.792-.759V46.884c0-.891.649-.967,1.222-.967.495,0,1.11.1,1.275.736l1.717,6.822c.011.066.021.12.077.12s.065-.032.088-.12l1.716-6.822c.165-.66.825-.736,1.342-.736.561,0,1.156.131,1.156.967V54.52c0,.484-.242.759-.815.759a.689.689,0,0,1-.781-.759Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67297"
                    data-name="Path 67297"
                    d="M660.692,46.323a.8.8,0,0,1,.672-.406.768.768,0,0,1,.7,1.21l-2.96,4.323v3.07a.692.692,0,0,1-.792.759c-.562,0-.8-.275-.8-.759V51.45l-2.96-4.323a.886.886,0,0,1-.142-.429.865.865,0,0,1,.869-.781.777.777,0,0,1,.648.406l2.388,3.521Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67298"
                    data-name="Path 67298"
                    d="M669.668,53.464a.424.424,0,0,0,.473-.473V48.744a.42.42,0,0,0-.473-.473h-5.622a.71.71,0,1,1,0-1.419h6.161c1.045,0,1.474.4,1.474,1.474V53.42c0,1.089-.451,1.474-1.474,1.474h-6.271a.715.715,0,1,1,0-1.43Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67299"
                    data-name="Path 67299"
                    d="M673.946,46.819c0-.319.088-.737.759-.737.528,0,.781.231.781.737v6.732c0,.176,0,.364.286.364a6.134,6.134,0,0,0,3.531-1.629,7.2,7.2,0,0,0,1.552-2.4c.132-.285.264-.439.572-.439s.88.209.88.693a6.141,6.141,0,0,1-1.32,2.5,7.943,7.943,0,0,1-4.379,2.585,5.637,5.637,0,0,1-1.484.265c-.771,0-1.178-.275-1.178-1.046Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67300"
                    data-name="Path 67300"
                    d="M690.623,47.467c.8,0,1.1.4,1.1.969a8.18,8.18,0,0,1-2.95,5.434,9.739,9.739,0,0,1-4.455,1.826.708.708,0,0,1-.726-.758c0-.474.209-.539,1.023-.738a6.513,6.513,0,0,0,5.468-5.182c0-.209-.143-.209-.418-.209h-3.245c-.551.748-1.937,2.289-2.685,2.289a.764.764,0,0,1-.716-.737c0-.3.089-.363.595-.738a8.734,8.734,0,0,0,2.3-2.673c.407-.814.484-1,.946-1,.33,0,.782.176.782.573a2.026,2.026,0,0,1-.353.945Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67301"
                    data-name="Path 67301"
                    d="M695.869,51.318a17.583,17.583,0,0,0-2.123-.891c-.319-.12-.627-.264-.627-.67a.676.676,0,0,1,.638-.727,9.365,9.365,0,0,1,2.189.7c.859.363,1.189.517,1.189,1a.739.739,0,0,1-.66.782,1.419,1.419,0,0,1-.606-.2m6.525-2.606a9.216,9.216,0,0,1-2.982,4.741,9.558,9.558,0,0,1-4.984,1.98.749.749,0,0,1-.759-.8c0-.583.506-.671.814-.715a8.227,8.227,0,0,0,4.192-1.728,7.832,7.832,0,0,0,1.936-2.816c.418-1.045.44-1.078.572-1.2a.512.512,0,0,1,.4-.132c.143,0,.815.1.815.672m-5.6-.254a16.61,16.61,0,0,0-2.123-.88c-.3-.11-.627-.265-.627-.671,0-.209.11-.737.638-.737a9.958,9.958,0,0,1,2.189.7c.88.374,1.189.527,1.189,1.012a.739.739,0,0,1-.661.781,1.5,1.5,0,0,1-.6-.209"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67302"
                    data-name="Path 67302"
                    d="M704.372,52.286a.579.579,0,0,1-.649-.627.573.573,0,0,1,.649-.627h4.687V49.845a.329.329,0,0,0-.375-.375h-4.4a.644.644,0,1,1,0-1.288h4.862c1.045,0,1.277.53,1.277,1.278V54c0,1.023-.495,1.276-1.277,1.276H704.2a.593.593,0,0,1-.672-.649.605.605,0,0,1,.672-.66h4.488a.328.328,0,0,0,.375-.374v-1.31Z"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67303"
                    data-name="Path 67303"
                    d="M712.654,46.555c.209,0,.407.077,1.222.516,2.453,1.343,2.453,1.541,2.453,1.871a.9.9,0,0,1-.737.815c-.286,0-.529-.166-1.177-.617a20.3,20.3,0,0,0-1.947-1.133c-.253-.132-.551-.3-.551-.671a.847.847,0,0,1,.6-.771.928.928,0,0,1,.142-.01m8.549,1.694a10.511,10.511,0,0,1-2.08,4.147,8.207,8.207,0,0,1-4.39,2.63,9.571,9.571,0,0,1-1.793.33.758.758,0,0,1-.769-.836c0-.55.307-.66.824-.726,3.114-.363,5.336-1.563,6.667-5.468.2-.572.265-.77.693-.77a1.344,1.344,0,0,1,.276.033.679.679,0,0,1,.572.66"
                    transform="translate(-10880.257 -214)"
                    fill="#ffffe5"
                  />
                </g>
                <g id="Group_12765" data-name="Group 12765" transform="translate(-10213.395 -245)">
                  <g
                    id="Group_12764"
                    data-name="Group 12764"
                    transform="translate(0 0)"
                    clipPath="url(#clip-path)"
                  >
                    <path
                      id="Path_67319"
                      data-name="Path 67319"
                      d="M8.44.024.157,3.666A.263.263,0,0,0,0,3.906v9.539a.263.263,0,0,0,.157.24L8.44,17.327a.288.288,0,0,0,.235,0l8.284-3.642a.263.263,0,0,0,.157-.24V3.906a.263.263,0,0,0-.157-.24L8.675.024a.292.292,0,0,0-.235,0"
                      transform="translate(0 0)"
                      fill="#ffffe5"
                    />
                    <path
                      id="Path_67320"
                      data-name="Path 67320"
                      d="M10.283,6.306a6.294,6.294,0,0,0,2.642.523,6.3,6.3,0,0,0,2.642-.523c.721-.344,1.118-.806,1.118-1.3s-.4-.957-1.118-1.3a6.3,6.3,0,0,0-2.642-.522,6.294,6.294,0,0,0-2.642.522c-.721.344-1.118.806-1.118,1.3s.4.957,1.118,1.3"
                      transform="translate(-4.365 -1.515)"
                      fill="#ce323a"
                    />
                    <path
                      id="Path_67321"
                      data-name="Path 67321"
                      d="M15.87,19.507a.393.393,0,0,1-.393-.393V11.609a.393.393,0,0,1,.229-.357l6.958-3.195a.393.393,0,0,1,.327.714l-6.73,3.09v7.254a.393.393,0,0,1-.393.393"
                      transform="translate(-7.371 -3.82)"
                      fill="#ce323a"
                    />
                    <path
                      id="Path_67322"
                      data-name="Path 67322"
                      d="M9.511,12a.394.394,0,0,1-.163-.035l-6.992-3.2a.393.393,0,0,1,.326-.715l6.992,3.195A.393.393,0,0,1,9.511,12"
                      transform="translate(-1.013 -3.82)"
                      fill="#ce323a"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        )}

        <div
          className="item-menu d-flex align-items-center justify-content-center"
          onClick={gotoNews}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="60.822"
            height="17.398"
            viewBox="0 0 60.822 17.398"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_7066"
                  data-name="Rectangle 7066"
                  width="14.222"
                  height="17.398"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g id="Group_12775" data-name="Group 12775" transform="translate(10101.046 245)">
              <g id="Group_12761" data-name="Group 12761" transform="translate(21.714 -72.001)">
                <path
                  id="Path_67289"
                  data-name="Path 67289"
                  d="M781.178,49.657a6.232,6.232,0,0,1,1.055-.088,5.439,5.439,0,0,1,3.015.815,2.931,2.931,0,0,1-1.045,4.96,5.921,5.921,0,0,1-1.9.288c-.441,0-1.013,0-1.013-.716,0-.6.474-.6.771-.6.781,0,2.618,0,2.618-1.717,0-1.54-1.364-1.759-2.4-1.759a5.427,5.427,0,0,0-1.1.088v1.715c0,1.056,0,2.96-2.036,2.96a2.31,2.31,0,0,1-2.366-2.377c0-2.1,2.058-2.9,3-3.255V48.721c-.671.023-2.047.023-2.079.023-.386,0-.847,0-.847-.671s.517-.66.814-.66c1.331,0,1.485,0,2.112-.022V46.61c0-.275.011-.738.694-.738s.7.441.7.738v.715c.934-.045,1.045-.045,1.143-.045a.608.608,0,0,1,.715.66c0,.474-.285.6-.374.617a7.646,7.646,0,0,1-1.484.1ZM779.8,51.3c-.583.232-1.672.749-1.672,1.827a1.052,1.052,0,0,0,.946,1.122c.495,0,.726-.463.726-1.651Zm3.95-4.973c.7,0,2.706,1.729,2.706,2.486a.78.78,0,0,1-.781.727c-.3,0-.385-.121-.738-.615a5.138,5.138,0,0,0-1.54-1.431.583.583,0,0,1-.165-.946.813.813,0,0,1,.518-.221"
                  transform="translate(-10880.714 -214.619)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67290"
                  data-name="Path 67290"
                  d="M787.975,51.461a.574.574,0,0,1-.671-.616c0-.451.154-.693.671-.693h1.848V48.3h-.561a7.991,7.991,0,0,1-.616,1.013.642.642,0,0,1-.54.319.753.753,0,0,1-.748-.638c0-.2.011-.22.5-.936a9.729,9.729,0,0,0,.923-1.969c.111-.3.221-.472.573-.472s.748.2.748.56a2.86,2.86,0,0,1-.242.825h2.233a.575.575,0,0,1,.672.617c0,.451-.155.681-.672.681h-.924v1.849h1.166c.221,0,.671.022.671.616,0,.484-.176.693-.671.693h-1.287a.944.944,0,0,1-.022.165,7.522,7.522,0,0,0,1.662,2.454.68.68,0,0,1-.462,1.2c-.253,0-.408-.121-.694-.485a10.2,10.2,0,0,1-.957-1.561,6.126,6.126,0,0,1-1.882,2.552c-.241.2-.351.253-.505.253a.834.834,0,0,1-.759-.759.808.808,0,0,1,.374-.583,4.917,4.917,0,0,0,1.9-3.235Zm9.439,3.07c0,.957-.4,1.276-1.266,1.276h-1.836c-.87,0-1.265-.319-1.265-1.276V47.479c0-.979.418-1.277,1.265-1.277h1.836c.848,0,1.266.287,1.266,1.277ZM796.083,47.9a.338.338,0,0,0-.385-.385h-.979a.335.335,0,0,0-.374.385V54.09a.328.328,0,0,0,.374.374h.979a.336.336,0,0,0,.385-.374Z"
                  transform="translate(-10880.714 -214.619)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67291"
                  data-name="Path 67291"
                  d="M804.19,49.448c1.254,0,3.367.462,3.367,2.762,0,2.925-2.861,3.322-4.819,3.322a10.707,10.707,0,0,1-2.728-.309.664.664,0,0,1-.4-.637.608.608,0,0,1,.639-.661,2.107,2.107,0,0,1,.45.067,10.975,10.975,0,0,0,1.97.2,5.709,5.709,0,0,0,2.42-.451,1.575,1.575,0,0,0,.935-1.541,1.355,1.355,0,0,0-.516-1.067,2.729,2.729,0,0,0-1.541-.407,4.9,4.9,0,0,0-3.366,1.222c-.308.308-.462.45-.859.45-.516,0-.748-.308-.748-.924s.1-2.421.165-2.948c.056-.385.132-.727.716-.727.56,0,.748.254.748.606,0,.055-.066.648-.077.769a12.427,12.427,0,0,0-.111,1.42,6.674,6.674,0,0,1,3.752-1.144m1.727-1.672a.809.809,0,0,1-.55.132,32.612,32.612,0,0,1-4.081-.407c-.99-.155-1.309-.264-1.309-.76,0-.066,0-.7.627-.7.131,0,.572.088.858.142a23.931,23.931,0,0,0,3.443.342c.891.032,1.243.076,1.243.758a.69.69,0,0,1-.231.5"
                  transform="translate(-10880.714 -214.619)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67292"
                  data-name="Path 67292"
                  d="M811.835,52.276c-.012,1.539.3,1.858,2.409,1.858a15.167,15.167,0,0,0,2.234-.153,3.984,3.984,0,0,1,.637-.056.622.622,0,0,1,.627.694.643.643,0,0,1-.583.692,17.518,17.518,0,0,1-2.761.177c-2.178,0-3.311-.275-3.785-1.519a7.013,7.013,0,0,1-.2-1.683V49.778c-.165.012-.924.044-1.078.044a.623.623,0,0,1-.7-.683c0-.637.473-.67.737-.681.286-.011.759-.022,1.057-.034v-1.6c0-.309.044-.748.715-.748.6,0,.725.33.725.759l-.011,1.54c1.662-.055,1.849-.055,3.532-.1,0-.23-.032-1.287-.032-1.5,0-.352,0-.869.725-.869.484,0,.683.154.737.617.023.153.034,1.463.034,1.716.483,0,.99-.011,1.176-.011.265,0,.748,0,.748.671,0,.583-.384.671-.737.682-.011,0-1.056.022-1.177.022a7.406,7.406,0,0,1-.3,2.695,1.675,1.675,0,0,1-1.485.671,4.484,4.484,0,0,1-1.727-.352.653.653,0,0,1-.452-.627.61.61,0,0,1,.595-.66,1.778,1.778,0,0,1,.605.154,2.4,2.4,0,0,0,.726.133c.33,0,.506-.111.55-.606.011-.142.022-1.155.033-1.375-1.617.034-1.815.034-3.564.1Z"
                  transform="translate(-10880.714 -214.619)"
                  fill="#ffffe5"
                />
              </g>
              <g id="Group_12767" data-name="Group 12767" transform="translate(-10101.046 -245)">
                <g
                  id="Group_12766"
                  data-name="Group 12766"
                  transform="translate(0 0)"
                  clipPath="url(#clip-path)"
                >
                  <path
                    id="Path_67323"
                    data-name="Path 67323"
                    d="M12.354,10.337A5.136,5.136,0,0,0,10.818,6.4a5.389,5.389,0,0,0-3.708-1.3A5.389,5.389,0,0,0,3.4,6.4a5.136,5.136,0,0,0-1.536,3.939,12.279,12.279,0,0,1-1.8,7.055.5.5,0,0,0,.427.751H13.723a.5.5,0,0,0,.427-.751,12.279,12.279,0,0,1-1.8-7.055"
                    transform="translate(0 -2.426)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67324"
                    data-name="Path 67324"
                    d="M11.685,31.068a2.1,2.1,0,0,1-2.073-1.744.534.534,0,0,1,.113-.438.523.523,0,0,1,.4-.183H13.24a.525.525,0,0,1,.406.183.536.536,0,0,1,.112.438,2.1,2.1,0,0,1-2.073,1.744m-1.556-1.842h-.01a1.592,1.592,0,0,0,1.567,1.317,1.576,1.576,0,0,0,1.557-1.309Z"
                    transform="translate(-4.573 -13.67)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67325"
                    data-name="Path 67325"
                    d="M13.719,1.559A1.558,1.558,0,1,1,12.16,0a1.559,1.559,0,0,1,1.559,1.559"
                    transform="translate(-5.049 0)"
                    fill="#ffffe5"
                  />
                </g>
              </g>
            </g>
          </svg>
          {isLogin && <NotifyNews />}
        </div>
        <div
          className="d-flex align-items-center justify-content-center lottery-header"
          onClick={() => {
            history.push('/lottery');
          }}
        >
          <img src={TOP_IMAGES.LotteryHeaderSP} />
          <span className="AOTFShinMaruGoPro">くじ一覧</span>
        </div>
        <div
          className="d-flex align-items-center justify-content-center"
          onClick={() => {
            history.push('/guide');
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="79.407"
            height="17.621"
            viewBox="0 0 79.407 17.621"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_7802"
                  data-name="Rectangle 7802"
                  width="13.298"
                  height="17.621"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g id="Group_12774" data-name="Group 12774" transform="translate(9970.544 245)">
              <g id="Group_13473" data-name="Group 13473" transform="translate(-9970.544 -245)">
                <g
                  id="Group_13472"
                  data-name="Group 13472"
                  transform="translate(0 0)"
                  clipPath="url(#clip-path)"
                >
                  <path
                    id="Path_69256"
                    data-name="Path 69256"
                    d="M11.464,0a1.956,1.956,0,0,0-1.036.293L6.649,2.649,2.87.293A1.959,1.959,0,0,0,1.834,0,1.738,1.738,0,0,0,0,1.667V13.081a1.048,1.048,0,0,0,.493.889l5.6,3.491.033.02h0a.991.991,0,0,0,.149.071h.007a1.049,1.049,0,0,0,.725,0h0a1.031,1.031,0,0,0,.162-.076h0l.03-.019,5.6-3.491a1.048,1.048,0,0,0,.493-.889V1.667A1.738,1.738,0,0,0,11.464,0m.787,13.081-5.6,3.493V3.884l4.333-2.7a.912.912,0,0,1,.482-.134.719.719,0,0,1,.787.62Z"
                    transform="translate(0 0)"
                    fill="#ffffe5"
                  />
                </g>
              </g>
              <g id="Group_12762" data-name="Group 12762" transform="translate(45.714 -72.575)">
                <path
                  id="Path_67279"
                  data-name="Path 67279"
                  d="M890.745,55.147a16.9,16.9,0,0,1-3.532.308,17.624,17.624,0,0,1-2.067-.121c-.771-.1-2.828-.5-2.828-2.3a2.95,2.95,0,0,1,1.287-2.287.978.978,0,0,1,.594-.265.73.73,0,0,1,.759.671c0,.242-.187.418-.6.836-.484.463-.528.682-.528.924,0,1.023,1.793,1.144,3.1,1.144a16.9,16.9,0,0,0,2.97-.253,4.316,4.316,0,0,1,.836-.12.616.616,0,0,1,.693.66c0,.506-.187.67-.682.8m-6.854-7.141c-.352,0-.924-.01-.924-.7,0-.715.495-.715.946-.715.165,0,1.452.033,1.716.033.4,0,2.729-.056,3.224-.077.132,0,.561-.022.66-.022.407,0,.935.032.935.682,0,.451-.143.527-.88.978-.275.166-1.518.947-1.771,1.112a1.251,1.251,0,0,1-.683.263.7.7,0,0,1-.714-.67c0-.254.154-.408.593-.682.1-.066.583-.3.683-.363-1.134.088-2.651.164-3.785.164m5.1,1.454a.5.5,0,0,1-.044-.209c0-.221.243-.33.4-.33s.263.087.484.472a3.411,3.411,0,0,1,.406,1c0,.265-.274.341-.406.341a.319.319,0,0,1-.286-.2c-.077-.155-.209-.43-.275-.573-.034-.078-.231-.429-.276-.505m1.178-.518a.542.542,0,0,1-.055-.221c0-.209.242-.318.4-.318s.275.1.506.527a2.95,2.95,0,0,1,.363.925.369.369,0,0,1-.4.341.341.341,0,0,1-.286-.188c-.044-.076-.231-.472-.264-.548s-.231-.442-.264-.518"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67280"
                  data-name="Path 67280"
                  d="M895.915,48.524h1.3a.574.574,0,0,1,.67.615c0,.484-.253.65-.67.65h-1.277a10.313,10.313,0,0,0,1.243,1.793c.6.616.6.627.6.847,0,.353-.253.781-.627.781-.2,0-.4-.154-.671-.539a5.122,5.122,0,0,1-.572-.934v3.728c0,.176,0,.606-.617.606-.593,0-.681-.264-.681-.606V52.187a8.139,8.139,0,0,1-1.078,1.606c-.2.209-.33.319-.562.319a.777.777,0,0,1-.7-.77c0-.264.088-.341.683-.978a8.993,8.993,0,0,0,1.617-2.575H893.01c-.23,0-.681-.033-.681-.605,0-.451.2-.66.681-.66h1.607V47.4a13.492,13.492,0,0,1-1.408.121.592.592,0,0,1-.671-.649c0-.539.384-.572.781-.6.165-.011.924-.067,1.066-.076a17.33,17.33,0,0,0,2.52-.43,1.176,1.176,0,0,1,.253-.021c.528,0,.583.527.583.66,0,.527-.308.572-1.826.824Zm3.752,4.5c0,.164,0,.627-.661.627-.6,0-.726-.265-.726-.627V47.061c0-.154,0-.627.66-.627.562,0,.727.219.727.627Zm2.651,1.572a1.249,1.249,0,0,1-.594,1.232,4.46,4.46,0,0,1-1.629.143,2.975,2.975,0,0,1-.957-.055c-.4-.132-.418-.593-.418-.736,0-.693.452-.693.694-.693.153,0,.869.044,1.011.044.374,0,.518-.044.518-.4V46.257c0-.165,0-.627.638-.627.517,0,.737.176.737.627Z"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67281"
                  data-name="Path 67281"
                  d="M909.324,52.77v2.52c0,.275-.044.672-.6.672-.474,0-.7-.144-.7-.672V52.77h-2.3a7.07,7.07,0,0,1-.627,2.442c-.33.7-.528.815-.858.815a.811.811,0,0,1-.847-.759c0-.154.011-.166.462-1.035a6.549,6.549,0,0,0,.528-2.871v-3.9c0-1.056.452-1.375,1.365-1.375h6.007c.9,0,1.375.307,1.375,1.375v7.25c0,1.287-.682,1.287-1.871,1.287-.616,0-1.144,0-1.144-.738,0-.4.165-.681.627-.681.1,0,.561.011.66.011.242,0,.33-.122.33-.418v-1.4Zm-1.309-3.949V47.379h-1.859a.332.332,0,0,0-.374.375v1.067Zm0,1.21h-2.233v1.507h2.233Zm1.309-1.21h2.4V47.754a.337.337,0,0,0-.374-.375h-2.024Zm2.4,1.21h-2.4v1.507h2.4Z"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67282"
                  data-name="Path 67282"
                  d="M915.352,49.306c-.209,0-.759,0-.759-.683s.539-.692.759-.692h2.6c0-.375,0-.969.021-1.343.023-.308.111-.65.715-.65.771,0,.771.463.771.836,0,.209-.011.485-.034,1.157h2.662c1.354,0,1.376.857,1.376,1.847A22.32,22.32,0,0,1,923,54.289c-.429,1.189-1.288,1.287-2.343,1.287-1.222,0-1.739-.077-1.739-.825a.61.61,0,0,1,.682-.682c.188,0,.99.088,1.167.088.858,0,.945-.352,1.056-1.3.154-1.287.176-2.892.176-2.925,0-.441-.034-.627-.452-.627h-2.233a8.293,8.293,0,0,1-2.09,4.939c-.231.242-1.353,1.354-1.947,1.354a.8.8,0,0,1-.715-.771c0-.319.253-.507.527-.7a5.937,5.937,0,0,0,2.773-4.818Zm6.546-3.1a.74.74,0,0,1-.044-.23c0-.243.274-.309.4-.309.209,0,.3.133.463.529a4.143,4.143,0,0,1,.264.912c0,.353-.374.353-.4.353a.326.326,0,0,1-.319-.231c-.033-.088-.154-.473-.187-.561-.022-.066-.155-.4-.176-.463m1.287-.12a.462.462,0,0,1-.022-.177c0-.252.264-.33.4-.33.231,0,.3.144.451.507a3.76,3.76,0,0,1,.286.924c0,.33-.34.352-.4.352-.253,0-.275-.088-.517-.781-.022-.077-.177-.43-.2-.495"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67283"
                  data-name="Path 67283"
                  d="M931.026,55.037c0,.286-.055.726-.771.726-.539,0-.78-.231-.78-.726V50.329a15.013,15.013,0,0,1-3.917,1.4.76.76,0,0,1-.725-.825c0-.462.285-.55.627-.637a17.72,17.72,0,0,0,6.281-3.038l1.134-.978c.3-.254.428-.286.572-.286a.839.839,0,0,1,.824.792.794.794,0,0,1-.341.638,16.731,16.731,0,0,1-2.9,2.1Z"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67284"
                  data-name="Path 67284"
                  d="M937.88,55.014c0,.254-.023.76-.771.76s-.792-.473-.792-.76V46.686c0-.252.011-.769.77-.769s.793.472.793.769v2.047a25.758,25.758,0,0,1,4.323,1.738c.8.418.979.583.979.957a.867.867,0,0,1-.77.9,2.1,2.1,0,0,1-.946-.408c-.627-.374-1.541-.825-2.167-1.111a13.4,13.4,0,0,0-1.419-.55Zm2.7-8.207a.523.523,0,0,1-.044-.219c0-.265.3-.32.4-.32.22,0,.309.166.462.551a3.507,3.507,0,0,1,.265.891c0,.351-.363.351-.4.351a.319.319,0,0,1-.32-.219c-.032-.088-.153-.484-.186-.562s-.144-.4-.176-.473m1.287-.2a.558.558,0,0,1-.033-.176c0-.264.275-.33.407-.33.23,0,.3.153.462.539a3.084,3.084,0,0,1,.275.891c0,.318-.33.351-.4.351-.253,0-.3-.109-.517-.781-.022-.055-.154-.406-.2-.494"
                  transform="translate(-10880.032 -214)"
                  fill="#ffffe5"
                />
              </g>
            </g>
          </svg>
        </div>

        {!isLogin && (
          <div className="d-flex align-items-center justify-content-center" onClick={gotoRegister}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="64.271"
              height="18.819"
              viewBox="0 0 64.271 18.819"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_7074"
                    data-name="Rectangle 7074"
                    width="16.464"
                    height="18.819"
                    fill="none"
                  />
                </clipPath>
              </defs>
              <g id="Group_12773" data-name="Group 12773" transform="translate(9875.843 245)">
                <g id="Group_12763" data-name="Group 12763" transform="translate(19.714 -72.553)">
                  <path
                    id="Path_67285"
                    data-name="Path 67285"
                    d="M1008.771,49.811c-.407,0-.627-.143-.66-.551a4.884,4.884,0,0,1-1.617.716.769.769,0,0,1-.671-.825c0-.418.264-.551.594-.672a9.565,9.565,0,0,0,3.443-2.332c.44-.429.616-.594,1.188-.594s.715.154,1.353.769a9.208,9.208,0,0,0,3.323,2.2c.33.131.55.253.55.648a.774.774,0,0,1-.7.814,4.657,4.657,0,0,1-1.551-.7c-.055.474-.375.529-.672.529Zm1.518,2.31a17.906,17.906,0,0,1-1.089,2.19c1.562-.056,1.826-.078,4.126-.209-.165-.209-.221-.265-.65-.739-.242-.263-.286-.4-.286-.539,0-.33.408-.627.76-.627a.774.774,0,0,1,.561.288,16.242,16.242,0,0,1,1.462,1.638c.529.66.65.869.65,1.112a.878.878,0,0,1-.859.726.494.494,0,0,1-.439-.242c-.044-.067-.275-.418-.33-.5-1.145.133-2.333.221-3.5.3-.55.045-3.388.209-3.828.209-.176,0-.683,0-.683-.7a.571.571,0,0,1,.495-.639c.1-.011.869-.033,1.034-.033a14.268,14.268,0,0,0,1.057-2.233h-2.035c-.462,0-.672-.209-.672-.693a.581.581,0,0,1,.672-.616h8.6c.451,0,.671.186.671.682a.584.584,0,0,1-.671.627Zm2.7-3.531a10.556,10.556,0,0,1-1.617-1.453c-.165-.176-.21-.22-.309-.22s-.142.044-.307.22a11.35,11.35,0,0,1-1.618,1.453Z"
                    transform="translate(-10880.537 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67286"
                    data-name="Path 67286"
                    d="M1020.53,54.1a.752.752,0,0,1,.319.594c0,.285-.1.406-.836.681a11.225,11.225,0,0,1-2.442.65c-.441,0-.606-.462-.606-.759,0-.4.22-.451.661-.539a12.888,12.888,0,0,0,2.288-.627h-1c-.782,0-1.189-.265-1.189-1.19V50.229c0-.913.4-1.189,1.189-1.189h6.282c.8,0,1.2.276,1.2,1.189v2.683c0,.915-.407,1.19-1.2,1.19h-.98a11.8,11.8,0,0,0,2.245.638c.484.1.671.143.671.528,0,.23-.121.781-.616.781a11.293,11.293,0,0,1-2.365-.672c-.683-.263-.9-.351-.9-.693a.778.778,0,0,1,.307-.582Zm5.522-6.568c0,.923-.2,1.132-1.154,1.132h-5.677c-.935,0-1.144-.2-1.144-1.132v-.408c0-.913.186-1.133,1.144-1.133h5.677c.945,0,1.154.209,1.154,1.133Zm-1.011,2.937v-.187a.237.237,0,0,0-.264-.264h-5.436a.235.235,0,0,0-.263.264v.187Zm-5.963,1.32h5.963v-.463h-5.963Zm0,.847v.209a.237.237,0,0,0,.263.265h5.436a.24.24,0,0,0,.264-.265v-.209Zm5.611-5.413a.193.193,0,0,0-.221-.22h-4.841c-.142,0-.209.077-.209.22v.242c0,.133.056.221.209.221h4.841a.2.2,0,0,0,.221-.221Z"
                    transform="translate(-10880.537 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67287"
                    data-name="Path 67287"
                    d="M1031.178,49.866a.494.494,0,0,1-.572-.439,7.2,7.2,0,0,1-2.069,1.012.723.723,0,0,1-.682-.782.565.565,0,0,1,.419-.572,10.7,10.7,0,0,0,1.122-.473c-.1-.11-.451-.44-.683-.649a.5.5,0,0,1-.186-.385.7.7,0,0,1,.67-.637c.166,0,.253.042.638.373a8.988,8.988,0,0,1,.66.617c.232-.177.969-.76.969-.892s-.154-.121-.242-.121h-1.464a.493.493,0,0,1-.571-.517c0-.429.274-.539.571-.539h3.092c.429,0,.594,0,.825.209.121.1.561.627.649.726.088-.077.484-.451.627-.616.408-.44.452-.485.671-.485a.716.716,0,0,1,.7.606c0,.187-.088.308-.428.66-.144.143-.43.439-.7.682a3.929,3.929,0,0,0,.45.352,11.34,11.34,0,0,0,.914-.913c.4-.439.429-.484.638-.484a.751.751,0,0,1,.737.66c0,.2-.32.517-.562.77a6.338,6.338,0,0,1-.616.594,9.408,9.408,0,0,0,1.013.407.562.562,0,0,1,.472.583.756.756,0,0,1-.67.792,2.17,2.17,0,0,1-.826-.242,9.115,9.115,0,0,1-1.254-.7.484.484,0,0,1-.561.406Zm-1.232,3.444c-.936,0-.968-.528-.968-1.155v-.584c0-.934.2-1.154,1.154-1.154h5.854c.946,0,1.155.209,1.155,1.154v.584c0,.616-.033,1.155-.957,1.155h-.4a.368.368,0,0,1,.111.263,6.715,6.715,0,0,1-.276.9h1.805c.253,0,.671.045.671.593,0,.441-.144.684-.671.684h-8.758c-.22,0-.671-.023-.671-.595,0-.428.132-.682.671-.682h1.893a2.967,2.967,0,0,1-.33-.924.326.326,0,0,1,.109-.242Zm5.808-1.628c0-.132-.044-.253-.242-.253h-4.906c-.176,0-.253.076-.253.253v.374a.225.225,0,0,0,.253.253h4.906c.165,0,.242-.088.242-.253Zm-4.214,1.628a3.348,3.348,0,0,1,.342,1,.3.3,0,0,1-.044.164h2.332c.066-.187.165-.44.242-.716.1-.329.1-.362.165-.45Zm2.927-4.6a10.072,10.072,0,0,1-1.419-1.508,8.921,8.921,0,0,1-1.475,1.508Z"
                    transform="translate(-10880.537 -214)"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_67288"
                    data-name="Path 67288"
                    d="M1041.782,54.145a5.537,5.537,0,0,1,.781-.131.419.419,0,0,1,.286.1c.044-.032.11-.066.121-.076.385-.232.748-.452.946-.583.682-.462.7-.485.826-.485.3,0,.494.353.494.638a.55.55,0,0,1-.11.33,6.967,6.967,0,0,1-.814.672c-.726.506-.858.594-1.111.594a.488.488,0,0,1-.363-.143,14.692,14.692,0,0,1-3.444.748.444.444,0,0,1-.352-.121.746.746,0,0,1-.187-.528.546.546,0,0,1,.286-.55,10.235,10.235,0,0,1,1.563-.3v-2.85h-1.145c-.439,0-.627-.2-.627-.572,0-.43.275-.56.627-.56h1.145v-.848h-.594a.469.469,0,0,1-.539-.484.407.407,0,0,1-.188.043c-.363,0-.627-.428-.627-.725s.188-.495.529-.793a8.691,8.691,0,0,0,.923-1.012c.529-.715.627-.847,1.145-.847a.92.92,0,0,1,.857.484,12.337,12.337,0,0,0,.9,1.133c.253.275.374.4.374.6a.708.708,0,0,1-.66.639.272.272,0,0,1-.132-.033.7.7,0,0,1,.121.429c0,.561-.385.561-.55.561h-.484v.848h.858c.484,0,.55.285.55.593a.477.477,0,0,1-.55.539h-.858Zm-1.54-1.859a8.528,8.528,0,0,1,.186,1.332c0,.318-.176.516-.571.516s-.418-.186-.463-.528c-.022-.22-.187-1.309-.187-1.4,0-.175.143-.429.583-.429.287,0,.374.175.452.506m2.013-3.938a.621.621,0,0,1,.253.033,9.355,9.355,0,0,1-.9-1.123c-.176-.23-.2-.263-.276-.263s-.1.054-.2.2a13.7,13.7,0,0,1-.869,1.156Zm.99,3.784a9.378,9.378,0,0,1-.3,1.31c-.066.2-.132.362-.429.362-.088,0-.506-.032-.506-.429,0-.087.209-.913.242-1.089.076-.373.11-.561.429-.561.1,0,.561.022.561.407m3.421,2.618c0,1.112-.286,1.233-1.276,1.233-.154,0-.648,0-.781-.012-.473-.055-.484-.56-.484-.648,0-.639.44-.639.617-.639a4.039,4.039,0,0,0,.516,0c.165-.033.176-.209.176-.33v-3.9h-1.771c-.187,0-.539,0-.539-.562,0-.483.253-.571.539-.571h3.542v-.6h-2.992a.445.445,0,0,1-.517-.494c0-.474.308-.518.517-.518h2.992v-.33a.234.234,0,0,0-.263-.263h-2.883a.47.47,0,0,1-.539-.529c0-.407.143-.594.539-.594h3.278c.826,0,1.122.363,1.122,1.2V49.36h.309c.33,0,.483.22.483.539,0,.527-.34.55-.539.55h-2.046v.506a6.38,6.38,0,0,0,.452,1.034,8.019,8.019,0,0,0,.913-.968c.121-.144.219-.265.428-.265a.61.61,0,0,1,.583.584c0,.231-.044.385-.7,1.089-.175.177-.374.386-.571.55a6.469,6.469,0,0,0,1.154,1.155.7.7,0,0,1,.3.474.709.709,0,0,1-.649.759c-.155,0-.308-.034-.815-.55a5.993,5.993,0,0,1-1.089-1.64Zm-2.024-3.4a3.869,3.869,0,0,1,.407.616.655.655,0,0,1,.067.242.638.638,0,0,1-.583.583c-.21,0-.309-.154-.441-.33-.088-.121-.572-.7-.671-.837a.532.532,0,0,1-.121-.339.589.589,0,0,1,.506-.551c.187,0,.319,0,.836.616"
                    transform="translate(-10880.537 -214)"
                    fill="#ffffe5"
                  />
                </g>
                <g id="Group_12772" data-name="Group 12772" transform="translate(-9875.843 -245)">
                  <rect
                    id="Rectangle_7068"
                    data-name="Rectangle 7068"
                    width="14.504"
                    height="15.784"
                    transform="translate(0 0)"
                    fill="#ffffe5"
                  />
                  <g id="Group_12771" data-name="Group 12771" transform="translate(0 0)">
                    <g id="Group_12770" data-name="Group 12770" clipPath="url(#clip-path)">
                      <path
                        id="Path_67328"
                        data-name="Path 67328"
                        d="M14.042,3.847A2.148,2.148,0,1,1,11.894,1.7a2.148,2.148,0,0,1,2.148,2.148"
                        transform="translate(-4.642 -0.809)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67329"
                        data-name="Path 67329"
                        d="M11.441,10.652a2.65,2.65,0,0,0-2.645,2.5.149.149,0,0,0,.15.155h4.992a.15.15,0,0,0,.15-.155,2.65,2.65,0,0,0-2.646-2.5"
                        transform="translate(-4.189 -5.073)"
                        fill="#ce323a"
                      />
                      <rect
                        id="Rectangle_7069"
                        data-name="Rectangle 7069"
                        width="6.241"
                        height="0.876"
                        transform="translate(1.197 9.66)"
                        fill="#ce323a"
                      />
                      <rect
                        id="Rectangle_7070"
                        data-name="Rectangle 7070"
                        width="4.532"
                        height="0.876"
                        transform="translate(1.197 11.73)"
                        fill="#ce323a"
                      />
                      <rect
                        id="Rectangle_7071"
                        data-name="Rectangle 7071"
                        width="3.712"
                        height="0.876"
                        transform="translate(1.197 13.801)"
                        fill="#ce323a"
                      />
                      <rect
                        id="Rectangle_7072"
                        data-name="Rectangle 7072"
                        width="7.011"
                        height="3.637"
                        transform="translate(7.887 12.49) rotate(-45)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67330"
                        data-name="Path 67330"
                        d="M16.679,22a1.043,1.043,0,0,1-.741-.307l-2.572-2.572a1.047,1.047,0,0,1,0-1.481l4.958-4.958a1.047,1.047,0,0,1,1.481,0l2.572,2.572a1.047,1.047,0,0,1,0,1.481L17.419,21.7a1.043,1.043,0,0,1-.741.307m-1.091-3.619,1.091,1.09L20.155,16l-1.09-1.09Z"
                        transform="translate(-6.219 -5.896)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67331"
                        data-name="Path 67331"
                        d="M13.4,23.847l1.286,1.286,1.286,1.286L11.582,28.24Z"
                        transform="translate(-5.516 -11.358)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67332"
                        data-name="Path 67332"
                        d="M10.63,28.335a1.047,1.047,0,0,1-.967-1.448l1.821-4.393a1.047,1.047,0,0,1,1.708-.339l2.572,2.572a1.047,1.047,0,0,1-.339,1.708l-4.393,1.821a1.042,1.042,0,0,1-.4.08m2.189-3.591-.251.607.606-.251Z"
                        transform="translate(-4.564 -10.405)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67333"
                        data-name="Path 67333"
                        d="M12.493,28.041l.643.643.643.643-2.2.91Z"
                        transform="translate(-5.517 -13.355)"
                        fill="#ffffe5"
                      />
                      <path
                        id="Path_67334"
                        data-name="Path 67334"
                        d="M7.884,30.493l2.479-5.982,3.5,3.5Z"
                        transform="translate(-3.755 -11.674)"
                        fill="#ce323a"
                      />
                      <rect
                        id="Rectangle_7073"
                        data-name="Rectangle 7073"
                        width="7.011"
                        height="3.637"
                        transform="translate(7.887 12.49) rotate(-45)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67335"
                        data-name="Path 67335"
                        d="M17.3,21.943a.367.367,0,0,1-.261-.108l-2.572-2.572a.37.37,0,0,1,0-.523l4.958-4.958a.37.37,0,0,1,.523,0l2.572,2.572a.37.37,0,0,1,0,.523l-4.958,4.958a.367.367,0,0,1-.261.108M15.246,19,17.3,21.052l4.436-4.436-2.049-2.049Z"
                        transform="translate(-6.836 -6.513)"
                        fill="#ffffe5"
                      />
                      <path
                        id="Path_67336"
                        data-name="Path 67336"
                        d="M13.4,23.847l1.286,1.286,1.286,1.286L11.582,28.24Z"
                        transform="translate(-5.516 -11.358)"
                        fill="#ce323a"
                      />
                      <path
                        id="Path_67337"
                        data-name="Path 67337"
                        d="M11.246,28.273a.369.369,0,0,1-.341-.511l1.821-4.393a.369.369,0,0,1,.6-.119L15.9,25.822a.37.37,0,0,1-.119.6l-4.393,1.821a.375.375,0,0,1-.142.028m1.95-4.11-1.267,3.058,3.058-1.267Z"
                        transform="translate(-5.18 -11.022)"
                        fill="#ffffe5"
                      />
                      <path
                        id="Path_67338"
                        data-name="Path 67338"
                        d="M12.358,28.665l1.094,1.094-1.869.775Z"
                        transform="translate(-5.517 -13.652)"
                        fill="#ffffe5"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        )}
      </div>
    </header>
  );
}
